import HearingTest from './components/HearingTest';

const hearingTest = document.getElementById('hearingTest');

if (hearingTest) {
  window.hearingTest = new HearingTest();
}
